import { render, staticRenderFns } from "./commentsForm.vue?vue&type=template&id=7a11d8b5&"
import script from "./commentsForm.vue?vue&type=script&lang=js&"
export * from "./commentsForm.vue?vue&type=script&lang=js&"
import style0 from "./commentsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports